import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG, ApprovalStep, Page, QuoteFilter
} from '../api/models';
import { ConfiguratorContext } from '../context';
import {SorterResult} from "antd/lib/table/interface";

type  SortResult<T> = SorterResult<T> | SorterResult<T>[]

interface ApprovalStepProps {
  filter?: QuoteFilter
  current?: number
  pageSize?:number,
  sorter?:SortResult<ApprovalStep>
}

export const useApprovalSteps = (props?: ApprovalStepProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props?:ApprovalStepProps  ) : Promise<Page<ApprovalStep> | undefined> => {

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchApprovalSteps(cancelSource.token, props?.current, props?.pageSize);
      cancelTokenSourceRef.current = undefined;

      return resp.data
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
        'fetchApprovalSteps',
        props
      ],
      ([_k, p]) => fetcher(p),
      {
        dedupingInterval:1
      }
  );
};


export default useApprovalSteps;

